export default {
  hero: {
    title: '您的活动已上线',
    subtitle:
      'AhaCreator 正在根据全量达人池为您匹配达人，即将开始发送邀请。',
  },
  buttons: {
    backToHome: '返回首页',
  },
  whatNext: {
    title: '接下来会发生什么',
  },
  happeningNow: '进行中',
  timeline: {
    step1: {
      title: '活动已创建',
      desc: '策略已确认，预算已设置',
    },
    step2: {
      title: '活动审核中',
      desc: '我们的客户成功团队会在全面匹配开始之前对您的活动进行审查和优化。',
    },
    step3: {
      title: 'AhaCreator 正在匹配达人',
      desc: '根据您的策略进行全池匹配。首先会邀请您保存的影响力者。',
    },
    step4: {
      title: '达人收到邀请',
      desc: '匹配到的达人将查看您的简报并提交含报价的方案。',
    },
    step5: {
      title: '审核与批准',
      desc: '查看达人方案、协商条款并批准合作。',
    },
    step6: {
      title: '内容交付',
      desc: '达人创作并发布内容。在您批准后将处理付款。',
    },
  },
  whileWait: {
    title: '你也可以',
    desc: '配置达人简报、参考视频、发布指引与截止时间，让达人明确交付内容。',
  },
  cards: {
    goToDetails: {
      label: '前往详情',
      title: '查看活动详情',
    },
    newCampaign: {
      label: '新建活动',
      title: '再创建一个',
    },
  },
};
